// extracted by mini-css-extract-plugin
module.exports = {"image":"deleteAccountDialog_image__3kR_T","btnDelete":"deleteAccountDialog_btnDelete__d_jwk","text":"deleteAccountDialog_text__2otNW"};
    if(module.hot) {
      // 1783592056705
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  